'use strict';

const moment = require('moment');

require('moment-timezone');

const BookerModel = require('../../models/booker');

const BookerView = require('../../views/booker');

function gliveDealBookerInit(gliveBookerData) {
  if (!gliveBookerData) {
    return false;
  }

  const {
    calendar,
    deal,
    timezoneData,
    el,
    overlapWith,
    showSpinner,
    gliveAvailabilityHash,
    isTouch,
    recaptchaJsUrl,
    useNativeCheckout,
    useConsistentPriceBadging,
  } = gliveBookerData;

  if (timezoneData) {
    moment.tz.add(timezoneData);
  }

  const model = new BookerModel({
    bookAndBuy: true,
    calendar,
    deal,
    showSpinner,
    gliveAvailabilityHash,
    isTouch,
    recaptchaJsUrl,
    useNativeCheckout,
    useConsistentPriceBadging,
  });

  const view = new BookerView({
    attributes: { 'data-bhw': 'GliveBookingDealBooker' },
    el: el || '#deal-booker',
    overlapWith:
      overlapWith ||
      '#purchase-cluster .buy, #purchase-cluster .buy-for-friend-module, #purchase-cluster .limited-time, #purchase-cluster .deal-status, #purchase-cluster .deal-discount, #purchase-cluster .gift-card',
    model,
    templateName: 'deal_booker',
  });

  view.on('buy', option => {
    const buyUrl = option.get('buyUrl');

    window.location = buyUrl;
    return window.location;
  });

  if (!document.querySelectorAll('#purchase-cluster .buy').length) {
    view.setOpenAndLocked();
  }
  //HINT: I have to introduce grecaptcha in the scope, because
  //the isReadyToBook function is trying to access to it, but it
  //hasn't been loaded yet.
  if (!window.grecaptcha) {
    window.grecaptcha = {
      getResponse() {
        return '';
      },
    };
  }
  return new Promise((resolve, reject) => {
    if (view.render()) {
      resolve();
    } else {
      reject();
    }
  });
}

module.exports = gliveDealBookerInit;
